import React from "react";
import * as DIAG from "storm-react-diagrams";
import PreviewNodeLayerWidget from "./PreviewNodeLayerWidget";
import PreviewLinkLayerWidget from "./PreviewLinkLayerWidget";

export default class PreviewDiagramWidget extends DIAG.DiagramWidget {
    /**
     * Diagram widget for diagram preview; no event handling
     * @module PreviewDiagramWidget
     * @param {Object} diagramProps React props
     */
    constructor(diagramProps) {
        super(diagramProps);
    }

    onKeyUp(event) {
        event.preventDefault();
        event.stopPropagation();
    }

    getEngine() {
        return this.props.diagramEngine;
    }

    /**
     * Zoom the diagram to fit canvas size
     */
    fit(){
        this.props.diagramEngine.zoomToFit();
    }

    componentDidMount() {
        this.props.diagramEngine.enableRepaintEntities([]);
        super.componentDidMount();
        if (this.props.fitOnMount){
            this.fit();
        }
    }

    componentWillUpdate(nextProps) {
        const diagramModel = this.props.diagramEngine.diagramModel;
        
        if (diagramModel.id !== nextProps.diagramEngine.diagramModel.id) {
            nextProps.diagramEngine.diagramModel.rendered = true;
        }
        if (!nextProps.diagramEngine.diagramModel.rendered) {
            nextProps.diagramEngine.diagramModel.rendered = true;
        }
    }

    componentDidUpdate() {}

    componentWillUnmount(){}

    onMouseMove(event) {
        event.preventDefault();
        event.stopPropagation();
    }

    onMouseUp(event) {
        event.preventDefault();
        event.stopPropagation();
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        const diagramEngine = this.props.diagramEngine;
        const {node} = this.props;

        return (
            <div
                ref={ref => {
                    if (ref) {
                        this.props.diagramEngine.setCanvas(ref);
                    }
                }}
                className={"storm-diagrams-canvas preview"}
                
                onWheel={event => {
                    event.preventDefault();
                    event.stopPropagation();
                }}
                onContextMenu={event => {
                    event.preventDefault();
                    event.stopPropagation();
                }}
                onKeyDown={event => {
                    event.preventDefault();
                    event.stopPropagation();
                }}
                onKeyUp={event => {
                    event.preventDefault();
                    event.stopPropagation();
                }}
                onDoubleClick={event => {
                    event.preventDefault();
                    event.stopPropagation();
                }}
                onMouseMove={event => {
                    event.preventDefault();
                    event.stopPropagation();
                }}
                onMouseDown={event => {
                    event.preventDefault();
                    event.stopPropagation();
                }}
            >
                {/* DEVDES2-1046: Disabled modules cannot be dragged and dropped onto canvas */}
                {node && node.props.config.disabledInFlow && !this.props.isTargetModuleDisabledInFlow &&
                    <span id="preview-diagram-disabled-message">You cannot drag disabled modules onto the Canvas, but you can edited them directly.</span>
                }
                
                <PreviewNodeLayerWidget diagramEngine={diagramEngine}/>
                {this.state.renderedNodes && (
                    <PreviewLinkLayerWidget
                        diagramEngine={diagramEngine}
                        pointAdded={(point, event) => {}}
                    />
                )}
            </div>
        );
    }
}